import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import appconst from '@/lib/appconst';


interface BackShelvesState extends ListState<any> {
}

class BackShelvesMutations extends ListMutations<any>{

}
class BackShelves extends ListModule<BackShelvesState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
    }
    actions = {
        async getAll(context: ActionContext<BackShelvesState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Shelves/GetList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;

        },
        async Add(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/Shelves/Add', payload.data);
        },
        async Clear(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/Shelves/Clear', payload.data);
        },
        async Delete(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/Shelves/Delete', payload.data);
        },
    };
    mutations = {
        setCurrentPage(state: BackShelvesState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackShelvesState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const backShelves = new BackShelves();
export default backShelves;